import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { useToastContext } from '@/store/contexts/ToastContext'
import { useLoading } from '@/store/contexts/LoadingContext'
import { t } from '@/utils/i18n'
import PageHeader from '@/components/common/PageHeader/PageHeader'
import Card from '@/components/common/Card/Card'
import Button from '@/components/common/Button/Button'
import './Settings.css'

function Settings() {
  const navigate = useNavigate()
  const { language, toggleLanguage } = useLanguage()
  const { showToast } = useToastContext()
  const { stopLoading } = useLoading()

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => stopLoading())
    })
  }, [stopLoading])

  const handleLanguageChange = () => {
    toggleLanguage()
    showToast(
      language === 'ko' 
        ? 'Language changed to English' 
        : '언어가 한국어로 변경되었습니다.',
      'success'
    )
  }

  const handleTerms = () => {
    navigate('/settings/terms')
  }

  const handlePrivacy = () => {
    navigate('/settings/privacy')
  }

  return (
    <div className="settings">
      <PageHeader title={language === 'ko' ? '설정 및 정보' : 'Settings'} showBack={false} centerTitle titleVariant="settings" />
      <div className="settings__content">
        {/* 일반 설정 */}
        <Card className="settings__section">
          <h3 className="settings__section-title">
            {t('settings.general', language) || '일반'}
          </h3>
          <div className="settings__item">
            <div className="settings__item-info">
              <span className="settings__item-label">
                {t('settings.language', language) || '언어'}
              </span>
              <span className="settings__item-value">
                {language === 'ko' ? '한국어' : 'English'}
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLanguageChange}
            >
              {t('common.change', language) || '변경'}
            </Button>
          </div>
          <div className="settings__item">
            <div className="settings__item-info">
              <span className="settings__item-label">
                {t('settings.terms', language) || '이용약관'}
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleTerms}
            >
              {t('common.view', language) || '보기'}
            </Button>
          </div>
          <div className="settings__item">
            <div className="settings__item-info">
              <span className="settings__item-label">
                {t('settings.privacy', language) || '개인정보처리방침'}
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={handlePrivacy}
            >
              {t('common.view', language) || '보기'}
            </Button>
          </div>
        </Card>

        {/* 앱 정보 */}
        <Card className="settings__section">
          <h3 className="settings__section-title">
            {t('settings.appInfo', language) || '앱 정보'}
          </h3>
          <div className="settings__item">
            <div className="settings__item-info">
              <span className="settings__item-label">
                {t('settings.version', language) || '버전'}
              </span>
              <span className="settings__item-value">
                1.0.0
              </span>
            </div>
          </div>
        </Card>

      </div>
    </div>
  )
}

export default Settings

